import React, { Component } from "react";

import {
  Alert,
  TouchableOpacity,
  Content,
  View,
  Image,
  Navigator,
  Progress,
  Text,
  TextInput,
  StyleSheet
} from "react-1app";
import md5 from "md5";
import * as actions from "../redux/actions.js";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { load: false };
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  logar() {
    if (!this.state.login || this.state.login.length < 4) {
      Alert.alert("Atenção", "Verifique o úsuario");
      return;
    }
    if (!this.state.senha || this.state.senha.length < 4) {
      Alert.alert("Atenção", "Verifique a senha");
      return;
    }
    this.setState({ load: true });
    actions.logar(this.state.login, md5(this.state.senha), data => {
      if (data && data.objectId && data.ativo == true) {
        // this.props.screenProps.store.dispatch(action.logar(data))
        this.state.dispatch({
          type: "user_local",
          user_local: data
        });
        actions.changePage("Init");
      } else {
        if (data != undefined && data.msg != undefined) {
          alert(data.msg);
        }
      }
      this.setState({ load: false });
    });
  }

  render() {
    return (
      <Content style={styles.login}>
        <View style={styles.view1}>
          <Image
            style={styles.image}
            resizeMode={"contain"}
            source={"/img/logo-header.png"}
          />
        </View>
        <View style={styles.view21}>
          <TextInput
            style={styles.textinput1}
            value={this.state.login}
            onChange={value => {
              this.state.login = value;
              this.setState({ this: this.state.this });
            }}
            keyboardType={"default"}
            label={"Login"}
            ref={v => (this.login = v)}
          />
          <TextInput
            style={styles.textinput2}
            value={this.state.senha}
            onChange={value => {
              this.state.senha = value;
              this.setState({ this: this.state.this });
            }}
            keyboardType={"default"}
            label={"Senha"}
            onSubmitEditing={() => {
              this.logar();
            }}
            secureTextEntry={true}
            ref={v => (this.senha = v)}
          />

          {!this.state.load ? (
            <TouchableOpacity
              style={styles.entrar}
              onPress={() => {
                this.logar();
              }}
            >
              <Text style={styles.text}>{"Login"}</Text>
            </TouchableOpacity>
          ) : null}

          {this.state.load ? (
            <View style={styles.view2}>
              <Text style={styles.text3}>{"Carregando..."}</Text>
              <Progress style={styles.progress} />
            </View>
          ) : null}
        </View>
        <View style={styles.view3}>
          <Image
            style={styles.image2}
            source={"/img/logo-header.png"}
            resizeMode={"contain"}
          />
          <Text style={styles.text2}>
            {
              "© Copyright - 2014 - www.kaferchurrasqueiras.com.br. Todos os direitos reservados. As fotos aqui veiculadas, logotipo e marca são de propriedade do site www.kaferchurrasqueiras.com.br"
            }
          </Text>
        </View>
      </Content>
    );
  }
}

var styles = StyleSheet.create({
  login: {
    backgroundColor: "rgba(217,217,217,1)",
    alignSelf: "stretch",
    flex: 1,
    alignItems: "stretch",
    justifyContent: "stretch",
    flexDirection: "column"
  },
  view1: {
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  image: {
    width: 200,
    height: 200,
    alignSelf: "auto",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  view21: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  textinput1: {
    color: "rgba(0,0,0,1)",
    alignSelf: "center",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 20,
    width: 300
  },
  textinput2: {
    color: "rgba(0,0,0,1)",
    alignSelf: "center",
    textAlign: "left",
    fontWeight: "normal",
    marginTop: 20,
    width: 300,
    marginBottom: 20
  },
  entrar: {
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "column",
    width: 200,
    borderRadius: 10,
    backgroundColor: "rgba(255,135,0,1)"
  },
  text: {
    textAlign: "left",
    color: "rgba(255,255,255,1)",
    alignSelf: "center",
    fontWeight: "normal"
  },
  view2: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  text3: {},
  progress: {},
  view3: {
    alignSelf: "center",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    paddingTop: 123,
    paddingLeft: 100,
    maxWidth: 700
  },
  image2: {
    width: 100,
    height: 60,
    alignSelf: "auto",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  text2: {
    textAlign: "left",
    color: "rgba(111,111,111,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    fontSize: 11,
    marginLeft: 20
  }
});



// WEBPACK FOOTER //
// ./src/views/Login.js